<template>
	<div class="page">
		<Tip :tip="tip" />
		<TopTab :list='tabList' :tabIndex='tabIndex' @tabClick='tabClick' />
		<div class="screen_div">
            <el-input class="input" v-model="search.good_name" placeholder="商品名称" clearable />
			<el-select class="select" v-model="search.supplier_id" clearable placeholder="供货商家">
				<el-option v-for="item in allSuppliers" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id" />
			</el-select>
			<el-input class="input" v-model="search.order_no" placeholder="订单号" />
			<el-button plain @click="getAfterLists(1)">筛选</el-button>
		</div>
		<el-table class="table_div" :data="tableData" :header-cell-style="tabStyle">
			<el-table-column label="排序" type="index" width="100" align="center" />
			<el-table-column label="订单信息">
				<template slot-scope="scope">
					<div class="col">
						<span>单号：{{scope.row.order.order_no}}</span>
						<span>下单：{{scope.row.order.created_time}}</span>
						<!-- <span>账号：</span> -->
						<span>状态：{{scope.row.order.state_text}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="商品信息">
				<template slot-scope="scope">
					<div class="col">
						<span>名称：{{scope.row.good_name}}</span>
						<span>规格：{{scope.row.order_good.spec_data}}</span>
						<span>单价：{{scope.row.sale_price}}</span>
						<span>供货：{{scope.row.order_good.good_source_text}}</span>
						<span>类型：{{scope.row.order_good.good_type_text}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="售后信息">
				<template slot-scope="scope">
					<div class="col">
						<span>类型：{{scope.row.type_text}}</span>
						<span>退货数量：{{scope.row.quatity}}</span>
						<span>原因：{{scope.row.reasons_text}}</span>
						<span>描述：{{scope.row.desc}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="售后进程">
				<template slot-scope="scope">
					<div class="col">
						<span>申请：{{scope.row.created_time}}</span>
						<span>回馈：{{scope.row.handle_type_text}}</span>
						<!-- <span>寄回：2023-03-12 11:24 圆通速递 38832282883828</span>
						<span>收货：2023-03-12 11:24</span> -->
						<span>退款：{{scope.row.refund_time}} 金额：{{scope.row.refund_money}}元</span>
						<span>结果：{{scope.row.state_text}}</span>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="180">
				<template slot-scope="scope">
					<el-button class="item_btn" size="mini" type="primary" v-if="scope.row.state == 210" @click="open('goodsAfterSalEdit', scope.row.after_sale_id)">处理</el-button>
					<el-button class="item_btn" size="mini" type="danger" v-if="scope.row.state == 220" @click="open('goodsAfterSalRefund', scope.row.after_sale_id)">退款</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--弹出层-->
		<Popup :name="name" :type='type' :show="show" @close='close' div-style="width: 500px;height: max-content;"/>

        <div class="foot_div">
			<el-pagination class="pagination" background layout="prev, pager, next,jumper, ->, total" :total="total"
				@current-change="handleCurrentChange" :currentPage="search.page" :pageSize="search.limit">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import TopTab from "../../../components/TopTab/TopTab.vue"
	import Popup from "../../../components/Popup/Popup.vue"
    import {
        afterLists,
		supplierSelect,
	} from "../../../request/apis.js"
	export default {
		components: {
			Tip,
			TopTab,
			Popup
		},
		data() {
			return {
				tip: '用户在商城端订单管理中，对有问题商品发起售后，在此页面进行综合售后处理。',
				tabList: ['全部订单', '待处理','处理中','已完成'],
                tabMap:[],
				tabIndex: 0,
                total: 0,
                allSuppliers: [],
                loading: false,
				tableData: [],
				name:'',
				type:-1,
				show:false,
                search: {
                    supplier_id: '',
                    good_name: '',
                    order_no: '',
                    page: 1,
                    limit: 10,
                    state: 0,
                    good_source: 4,
                },
			}
		},
		computed: {
			tabStyle() {
				return {
					background: '#f5f5f5',
					color: '#333'
				}
			}
		},
        mounted() {
            this.getAfterLists();
			this.getSuppliers();
		},
		methods: {
            getAfterLists(page = 0){
                if(page){
                    this.search.page = page;
                }
                this.loading = true;
                afterLists(this.search).then(res => {
                    this.loading = false;
					if (res.code == 0) {
						this.total = res.count
						this.tableData = res.data

                        this.tabList = ['全部'];
                        this.tabMap = {'0': 0}; 
                        res.other.stateList.forEach((ele, index) => {
                            this.tabList.push(ele.message);
                            this.tabMap[index+1] = ele.code
                        });
					}else{
                        return this.message.error(res.msg);
                    }
				}).catch(err => {})
            },
            getSuppliers(){
                supplierSelect().then(res => {
                    if (res.code == 0) {
						this.allSuppliers = res.data
					}
                }).catch(err => {})
            },
			tabClick(index) {
				this.tabIndex = index;
                this.search.state = this.tabMap[index];
				this.getAfterLists(1);
			},
			open(name, type){
				this.name = name;
				this.type = type;
				this.show = true;
			},
			close(){
				this.show = false;
                this.getAfterLists();
			},
            //点击按钮切换页面
			handleCurrentChange(page) {
				this.search.page = page; //每次点击分页按钮，当前页发生变化
				this.getAfterLists();
			},
		}
	}
</script>

<style scoped>
	.screen_div {
		display: flex;
		flex-direction: row;
		width: 100%;
		height: auto;
		margin-top: 20px;
	}
	
	.col{
		display: flex;
		flex-direction: column;
	}
	
	.input {
		width: 130px;
		margin-right: 13px;
	}

	.select {
		width: 130px;
		margin-right: 13px;
	}

	.table_div {
		width: 100%;
		margin-top: 20px;
	}
	
	.el-button--mini {
		margin-right: 10px;
	}
	
	.item_btn {
		margin: 5px 5px 0 0;
	}
    .pagination {
		display: flex;
		justify-content: right;
		padding: 20px 30px 20px 30px
	}
</style>